import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksWaitingListAlert.module.scss';

interface Props {
  className?: string;
  termsUrl: string;
}

const BooksWaitingListAlert = ({
  className,
  termsUrl,
  intl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksWaitingListAlert, className);

  return (
    <div className={classes}>
      <p className={css.BooksWaitingListAlert__Paragraph}>
        {intl.formatMessage({ id: 'books.forms.waitingListAlertMessage1' })}
        <br />
        {intl.formatMessage({ id: 'books.forms.waitingListAlertMessage2' })}
      </p>
      <p className={css.BooksWaitingListAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.waitingListAlertMessage3"
          values={{
            terms: (
              <Link href={termsUrl} prefetch={false}>
                <a
                  className={css.BooksWaitingListAlert__Link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {intl.formatMessage({ id: 'books.forms.termOfUse' })}
                </a>
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default injectIntl(BooksWaitingListAlert);
